export const FormatDateWords = (dateString: string, langString:Intl.LocalesArgument = 'es-mx', options:Intl.DateTimeFormatOptions  = {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}): string => {
  const [day, month, year] = dateString.split('/');
  const date = new Date(+year, +month - 1, +day);
  return `${date.toLocaleDateString(langString, options)}`;
};
